<template>
<div class="textcontent">

  <br><br>

  <IconTable>
    <svg slot="ico">
      <text x="0" y="200" fill="none" stroke="black" stroke-width="4" class="material-icons anim_proj" style="font-size:200px;">extension</text>
    </svg>

    <!-- <ul>
      <li>Robot Karol javascript from scratch</li>                          .                  01.2015+01.2017
      <li>Selfdriving RC car arduino from scratch</li>                      .                  ??.2016
      <li>PDF generators timetable&Rechnung&Bingo&kinderkirche using ros ezpdf class</li>.     06.2017
      <li>(neural network from scratch in php)</li>                         .                  03.2016
      <li>ics generators php from scratch</li>                              .                  07.2017
      <li>timetable online creation php/html from scratch</li>              .                  10.2017
      LIFT                                                                  .                  03.2016
      ppp                                                                   .                  03.2016
      blackout                                                              .                  03.2017
      ubuntu online                                                         .                  06.2014
      startpage                                                             .                  03.2017
      pibot                                                                 .                  06.2015
      iserv scripts                                                         .                  08.2015
      rr apps                                                               .                  08.2016
      carolocup opencv lanedetection                                        .                  02.2016
      timelapse                                                             .                  11.2017
      Faceanimate                                                           .                  11.2017
      ff addons                                                             .                  03.2015
      vue webpage                                                           .                  01.2018
      sethc.exe                                                             .                  vor 05.2014
      wuerfeldev materializecss webseite                                    .                  04.2017
      Kamelgenerator                                                        .                  09.2015

    vue webseite              01.2018       1
    timelapse                 12.2017       1
    Faceanimate               11.2017       0
    rooster timetable         10.2017       0
    ics                       07.2017       0
    pdf generators            06.2017       0
    wuerfeldev materialzesite 04.2017       0
    blackout                  03.2017       0
    startpage                 03.2017       0
    robot Karol               01.2017       1
    rr app                    08.2016       0
    rc car schlangenlinie     ??.2016 05    1
    lane detection opencv     02.2016 04    1
    neural network            03.2016       0
    PPP                       03.2016       1
    LIFT                      03.2016       1
    Kamelgenerator            09.2015       0
    iserv scripts             08.2015       0
    pibot                     06.2015       1
    ff addons                 03.2015       0
    ubuntu "online"           06.2014       1
    sethc.exe                 05.2014       0


    </ul> -->
    <div class="display-1">Projects</div> More awesomeness is impossible. Probably.<br><br><br>
    <v-expansion-panel v-model="panelmodel" @input="setUrlTheRightWay()">
      <v-expansion-panel-content :lazy="true" v-for="(item,i) in $options.myProjs" :id="'pp'+i" class="projlist" v-bind:class="{isphone:$vuetify.breakpoint.smAndDown}"
        :key="i">
        <div slot="header">
          <v-icon style="float:right;padding-right:5px;padding-left:5px;">{{item.category}}</v-icon><span v-html="item.title"></span></div>
        <v-card>
          <v-card-text class="cardtext grey lighten-3" v-html="item.content"></v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>

  </IconTable>

  <!--
          <li>Robot Karol javascript from scratch</li>                          .                  01.2015+01.2017
          <li>Selfdriving RC car arduino from scratch</li>                      .                  ??.2016
          <li>PDF generators timetable&Rechnung&Bingo&kinderkirche using ros ezpdf class</li>.     06.2017
          <li>(neural network from scratch in php)</li>                         .                  03.2016
          <li>ics generators php from scratch</li>                              .                  07.2017
          <li>timetable online creation php/html from scratch</li>              .                  10.2017
          LIFT                                                                  .                  03.2016
          ppp                                                                   .                  03.2016
          blackout                                                              .                  03.2017
          ubuntu online                                                         .                  06.2014
          startpage                                                             .                  03.2017
          pibot                                                                 .                  06.2015
          iserv scripts                                                         .                  08.2015
          rr apps                                                               .                  08.2016
          carolocup opencv lanedetection                                        .                  02.2016
          timelapse                                                             .                  11.2017
          Faceanimate                                                           .                  11.2017
          ff addons                                                             .                  03.2015
          vue webpage                                                           .                  01.2018
          sethc.exe                                                             .                  vor 05.2014
          wuerfeldev materializecss webseite                                    .                  04.2017

vue webseite              01.2018       1   DONE
timelapse                 12.2017       1   DONE
Faceanimate               11.2017       0
rooster timetable         10.2017       0
ics                       07.2017       0
pdf generators            06.2017       0
wuerfeldev materialzesite 04.2017       0
blackout                  03.2017       0
startpage                 03.2017       0
robot Karol               01.2017       1   DONE
rr app                    08.2016       0
rc car schlangenlinie     ??.2016 05    1   DONE
lane detection opencv     02.2016 04    1   DONE
neural network            03.2016       0
PPP                       03.2016       1   DONE
LIFT                      03.2016       1   DONE
iserv scripts             08.2015       0
pibot                     06.2015       1   DONE
ff addons                 03.2015       0
ubuntu "online"           06.2014       1   DONE
sethc.exe                 05.2014       0

-->




</div>
</template>

<script>
import IconTable from '../components/IconTable.vue'
import ALL_PROJS from './data/projects.json'

export default {
  name: "projects-page",
  myProjs: ALL_PROJS,
  components: {
    IconTable
  },
  data() {
    return {
      panelmodel: null
    }
  },
  methods: {
    /*loadImg(boxfeld) { //My own lazy loading
      //var b = document.getElementById(a);
      //var b = b.getElementsByTagName("IMG");
      var b = document.querySelectorAll('#' + boxfeld + ' img');
      for (var i = 0; i < b.length; i++) {
        b[i].src = b[i].getAttribute("data-src");
      }
    }*/
    setUrlTheRightWay(){
      if(this.panelmodel==null){
        this.$router.replace('/projects/');
      }else{
        this.$router.replace('/projects/'+this.$options.myProjs[this.panelmodel]["id"]);
        this.setTargets();
        // this.$vuetify.goTo('#pp'+this.panelmodel) // doesnt work
      }
    },
    setTargets() {
      var lste = document.querySelectorAll('.v-expansion-panel__body a');
      for (var i = 0; i < lste.length; i++) {
        if (!lste[i].hasAttribute("target")) {
          if (!lste[i].getAttribute("href").startsWith("./")) {
            lste[i].setAttribute("target", "_blank");
          }
        }
      }
    }
  },
  beforeMount() {
    for(var i=0;i<this.$options.myProjs.length;i++){
      if(this.$options.myProjs[i]["id"]==this.$route.params.proj){
        this.panelmodel = i;
      }
    }
    this.setTargets();
  },
  mounted(){
    this.setTargets();
  },
  updated(){
    this.setTargets();
  }
}
</script>
<style>
.projlist *[src] {
  max-width: 100%;
  max-height: auto;
  height: auto;
}

.projlist iframe {
  width: 100%;
  height: 350%;
}

.projlist img {
  background: transparent url("../assets/loading.gif") no-repeat scroll center center;
  min-width: 50px;
  min-height: 50px;
  /* max-width: 100%; */
  /* max-height: auto; */
  /* max-width: calc( 100% + 2 * 16px );
  margin-left: -16px;
  margin-right: -16px; */
}


.projlist .rightthird img,
.projlist img.rightthird {
  width: 33%;
  float: right;
  padding: 6px;
  margin-right: -16px;
}

.projlist.isphone .rightthird img,
.projlist.mobile img.rightthird {
  width: 50%;
}


.projlist .cardtext {
  overflow-x: auto;
}


.anim_proj {
  animation: stroke_fill_proj 3s linear 0.2s forwards, pulsing_proj 15s ease 3.5s infinite;
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
  opacity: 0;
}

@keyframes stroke_fill_proj {
  0% {
    opacity: 0;
    stroke: black;
  }
  70% {
    stroke-dashoffset: 0;
  }
  100% {
    stroke-dashoffset: 0;
    opacity: 1;
    stroke: red;
  }
}

@keyframes pulsing_proj {
  0% {
    stroke: hsl(0, 100%, 50%);
  }
  10% {
    stroke: hsl(36, 100%, 50%);
  }
  20% {
    stroke: hsl(72, 100%, 50%);
  }
  30% {
    stroke: hsl(108, 100%, 50%);
  }
  40% {
    stroke: hsl(144, 100%, 50%);
  }
  50% {
    stroke: hsl(180, 100%, 50%);
  }
  60% {
    stroke: hsl(216, 100%, 50%);
  }
  70% {
    stroke: hsl(252, 100%, 50%);
  }
  80% {
    stroke: hsl(288, 100%, 50%);
  }
  90% {
    stroke: hsl(324, 100%, 50%);
  }
  100% {
    stroke: hsl(359, 100%, 50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/content/projects-page.vue